import { useNavigate } from 'react-router-dom';
import { ShoppingCart, Star } from 'lucide-react';
import { Button } from './ui/button';

export function RewardCard({ reward }) {
    const navigate = useNavigate();

    // Razorpay reward structure mapping
    // Prioritize brand name if the display name looks like test data or is missing
    const name = reward.brand?.name || reward.display_parameters?.name || reward.name;
    const description = reward.display_parameters?.description || reward.description;
    const image = reward.display_parameters?.image_url || reward.brand?.logo_url || 'https://via.placeholder.com/400';

    // Prices are in paise, convert to INR. 
    // Use amount if denominations are empty
    const rawPrice = reward.eligible_fixed_denomination?.[0] || reward.amount || 0;
    const price = rawPrice / 100;

    const formatPrice = (value) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0
        }).format(value);
    };

    const handleClick = () => {
        // Navigate to a special path or handle reward selection
        // Given the user flow, we might need a RewardPage or reuse ProductPage with state
        navigate(`/product/reward_${reward.id}`, { state: { reward } });
    };

    return (
        <div
            onClick={handleClick}
            className="group cursor-pointer bg-white rounded-3xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300"
        >
            <div className="relative aspect-square bg-white border-b border-gray-50 flex items-center justify-center overflow-hidden">
                <img
                    src={image}
                    alt={name}
                    className="max-w-full max-h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                />

                {/* Quick Buy Overlay */}
                <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <Button
                        className="w-full bg-primary hover:bg-primary/90 text-white rounded-full font-body text-sm"
                    >
                        Buy Now
                    </Button>
                </div>
            </div>

            <div className="p-4">
                <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1 font-body">
                    Gift Card
                </p>
                <h3 className="font-body font-medium text-secondary mb-2 line-clamp-1 group-hover:text-primary transition-colors">
                    {name}
                </h3>

                <div className="flex items-center justify-between mt-auto">
                    <span className="font-body font-semibold text-secondary text-lg">
                        Starts @ {formatPrice(price)}
                    </span>
                    <div className="flex items-center gap-1">
                        <Star className="w-3 h-3 fill-warning text-warning" />
                        <span className="text-xs font-medium text-secondary">4.8</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
